<template>
  <div class="wrapper">
    <div class="bkg"></div>
    <div class="overlay"></div>
    <div style="margin-top: -120px">
      <p>WHAT'S YOUR NAME?</p>
      <p v-if="this.error" style="color: red">{{this.error}}</p>
      <input @keydown="keydown" maxlength="13" type="" name="" v-model="name" placeholder="shawn">
      <button v-on:click="setName()" class="btn btn-fill">SUBMIT</button>
    </div>

    <div class="copy">
      <span>terms</span>
      <span>privacy</span>
    </div>
  </div>
</template>

<script>
import store from '../store';

export default {
  name: 'Landing',
  data: function() {
    return {
      error: null,
      name: ''
    }
  },
  props: {
    msg: String
  },
  methods: {
    keydown(e) {
      if(e.which === 13) this.setName();
    },
    setName() {
      if(!/^[a-zA-Z0-9]*$/.test(this.name))
        return this.error = 'Only alpha numeric characters';

      if(this.name.length > 13)
        return this.error = 'Must be less than 13 characters';

      store.setName(this.name);
      store.setView(3);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
  .bkg {
    /*background-image: url(https://i.imgur.com/F7TVFU6.jpg);*/
    /*background-image: url(https://i.imgur.com/NtW6btC.png);*/
    /*background-image: url(https://i.imgur.com/KOPB6iA.jpg);*/
    /*background-image: url(https://i.imgur.com/guRReko.jpg);*/
    background-image: url(http://24kgoldn.com/sketchy.jpg);
    background-size:cover;
    background-position: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: -2;
    opacity: .8;
  }
  .overlay {
    width: 100vw;
    height: 100vw;
    z-index: -1;
    backdrop-filter: blur(5px);
    position: fixed;
  }
  .wrapper {
    width: 100vw;
    height: 100%;
    height: -webkit-fill-available;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .copy {
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: #fff;
  }
  .copy span {
    margin: 5px;
  }
  p {
    color: #fff;
    font-size: 38px;
  }

  button {
    border-radius: 0;
    border: 0;
    background-color: #fff;
    font-size: 16px;
    /*font-family: 'Bebas Neue', cursive;*/
    padding: 10px 40px;
  }


  .btn {
    background: rgba(255, 255, 255, .2);
    box-shadow: 0px 0px 6px #00000079;
    border: 3px solid #FFFFFF;
    border-radius: 12px;
    opacity: 1;
    backdrop-filter: blur(30px);
    padding: 10px;
    margin: 0 5px;

    width: 300px;

    text-align: center;
    font-size: 28px;
    color: #FFFFFF;

    transition: background .2s ease;
    cursor: pointer;
  }

  .btn:hover {
    background: rgba(255, 255, 255, .25);
  }

  input {
    box-sizing: border-box;
    display: block;
    outline: none;
    margin: 10px;
    border-radius: 12px;
    width: 300px;
    padding: 8px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border: 4px solid #fff;
    background: none;
  }
</style>
